import { lazyPanes } from '@/lib/lazy-panes'

/** The offer screen's panes, off the /offers list chunk; the `$offerId` loader preloads them. */
export const offerDetail = lazyPanes(() => import('./offer-detail-panes'))
